module.exports = __webpack_public_path__ + "static/media/132.f8d2e82b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/132.jpg
// module id = 935
// module chunks = 0